import React, { FC, ReactNode } from 'react';

interface ICollectionProps {
  children: ReactNode | ReactNode[];
}

export const CollectionForm: FC<ICollectionProps> = ({ children }) => {
  return <div className="[&>*:not(:last-child)]:mb-[20px]">{children}</div>;
};

interface ICollectionItemProps {
  onCreate: () => void;
  onRemove: () => void;
  index: number;
  children: ReactNode | ReactNode[];
  gap?: string;
}

export const CollectionFormItem: FC<ICollectionItemProps> = ({
  children,
  onCreate,
  onRemove,
  index,
  gap = '10px',
}) => {
  return (
    <div className={`flex gap-[${gap}] items-baseline w-full`}>
      {index === 0 ? (
        <div
          onClick={() => onCreate()}
          className="cursor-pointer bg-[#232225] w-[16px] h-[16px] rounded-[50%] flex items-center justify-center"
        >
          +
        </div>
      ) : (
        <div
          onClick={() => onRemove()}
          className="cursor-pointer bg-[#232225] w-[16px] h-[16px] rounded-[50%] flex items-center justify-center"
        >
          -
        </div>
      )}
      {children}
    </div>
  );
};
export const AgencyAccountCollectionFormItem: FC<ICollectionItemProps> = ({
  children,
  onCreate,
  onRemove,
  index,
  gap = '10px',
}) => {
  return (
    <div className={`flex gap-[${gap}] items-baseline`}>
      {index === 0 ? (
        <div
          onClick={() => onCreate()}
          className="cursor-pointer bg-[#232225] w-[16px] h-[16px] rounded-[50%] flex items-center justify-center"
        >
          +
        </div>
      ) : (
        <div
          onClick={() => onRemove()}
          className="cursor-pointer bg-[#232225] w-[16px] h-[16px] rounded-[50%] flex items-center justify-center"
        >
          -
        </div>
      )}
      {children}
    </div>
  );
};
